enum WorkspaceSections {
  Models = 'models',
  ModelAPIs = 'model-apis',
  Chains = 'chains',
  Training = 'training',
  Overview = 'overview',
}

interface MatchParams {
  section?: WorkspaceSections;
}

enum Filter {
  All = 'all',
  RUNNING = 'running',
  SCALED_TO_ZERO = 'scaled_to_zero',
  INACTIVE = 'inactive',
  FAILED = 'failed',
}

enum SortBy {
  PRODUCTION = 'production',
  RECENTLY_ACTIVE = 'recently_active',
  CREATED = 'created',
}

enum SortByTraining {
  RECENTLY_ACTIVE = 'recently_active',
  CREATED = 'created',
}

export { WorkspaceSections, MatchParams, Filter, SortBy, SortByTraining };
